import React from 'react';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';

const PREFIX = 'CircularSpinner';

const classes = {
	root: `${PREFIX}-root`
};

const Root = styled('div')(({ theme }) => ({
	[`&.${classes.root}`]: {
		display: 'flex',
		'& > * + *': {
			marginLeft: theme.spacing(2)
		}
	}
}));

export default function CircularSpinner(props) {
	return (
		<Root className={classes.root}>
			<CircularProgress color="primary" {...props} />
		</Root>
	);
}
